const CLOUDFRONT_IMAGES_URL = __CLOUDFRONT_IMAGES_URL__;
const S3_IMAGE_BUCKET = __S3_IMAGE_BUCKET__;

const typeMapping = {
    service: 'service_photos',
    profile: 'profile_photos',
    common: 'common',
    shared: 'shared',
};

function getImageURL(key, width, height, type, fit) {
    if (typeof key !== 'string') {
        return null;
    }
    if (
        key.startsWith('http') ||
        key.startsWith('/') ||
        key.startsWith('data:image')
    ) {
        return key;
    }
    const req = {
        bucket: S3_IMAGE_BUCKET,
        key: `${typeMapping[type]}/${key}`,
    };

    if (width && height) {
        const resize = {
            width: width * 2,
            height: height * 2,
        };
        if (fit) {
            resize.fit = fit;
        }
        req.edits = {
            resize,
            rotate: null,
        };
    }
    const paramsJson = JSON.stringify(req);
    const urlPath = btoa(paramsJson);
    return `${CLOUDFRONT_IMAGES_URL}/${urlPath}`;
}

export const PDF_LOGO_MAX_PX = 128;

export function getPdfLogoImageURL(key, maxPx = PDF_LOGO_MAX_PX) {
    return getImageURL(key, maxPx, maxPx, 'service', 'inside');
}

export default getImageURL;
